module.exports = __webpack_public_path__ + "static/img/20-1016-cover.2b2631e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/news/20-1016-cover.jpg
// module id = qkCB
// module chunks = 0